import { Theme } from '@mui/material/styles'
//
import { semantic } from '../tokens/semantic'
import { SigStarIcon } from './CustomIcons'

// ----------------------------------------------------------------------

export default function Rating(theme: Theme) {
  const tokens = semantic[theme.palette.mode]

  // The stroke is the meaning-bearing layer (4.86:1 on white); it is the fill's
  // own hue darkened, not ink — a near-black outline this heavy dragged the star
  // towards olive. Empty stars keep the same geometry with a sunken fill and a
  // muted stroke, so "4 of 5" reads by shape even for a user who can't see amber.
  const strokeStyle = {
    strokeWidth: 1.7,
    strokeLinejoin: 'round' as const,
    strokeLinecap: 'round' as const,
  }

  return {
    MuiRating: {
      defaultProps: {
        emptyIcon: <SigStarIcon />,
        icon: <SigStarIcon />,
      },
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            opacity: 0.48,
          },
        },
        iconFilled: {
          color: tokens.star,
          '& path': { stroke: tokens.sigStroke, ...strokeStyle },
        },
        iconEmpty: {
          color: tokens.surface2,
          '& path': { stroke: tokens.ink3, ...strokeStyle },
        },
        sizeSmall: {
          '& svg': {
            width: 20,
            height: 20,
          },
        },
        sizeLarge: {
          '& svg': {
            width: 28,
            height: 28,
          },
        },
      },
    },
  }
}
